import { useAuth0 } from "@auth0/auth0-react";
import MyTable from "components/Table";
import { useFormik } from "formik";
import FinanceService from "Lib/API/Finance";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import CsvDownloader from "react-csv-downloader";
import { toastr } from "react-redux-toastr";
import { useReactToPrint } from "react-to-print";
import { DateFormetContext } from "../../../../app/App.js";
import "../../index.scss";

const PaymentTable = ({ refresh, value, ...props }) => {
  const dateFormet = React.useContext(DateFormetContext);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [total, setTotal] = React.useState();
  const [size, setSize] = React.useState(6);
  const { getAccessTokenSilently } = useAuth0();

  const enableLoading = (value) => {
    setLoading(value);
  };
  // getPaymentRequests

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await FinanceService.getPaymentRequests(
        "/filter?status=Unpaid",
        page,
        size,
        token
      )
        .then((res) => {
          if (res?.payRequests?.length) {
            res.payRequests.map((item) => {
              item.id = item._id;
              return item;
            });
            setTotal(res.total);
            setList(res.payRequests);
          }
          enableLoading(false);
        })
        .catch((err) => {
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
    enableLoading(true);
  }, [getAccessTokenSilently, page, refresh]);
  useEffect(() => {
    props.setColToCsv(columns);
  }, []);
  const columns = [
    {
      field: "pay_req_id",
      resizable: true,
      headerName: "ID",
      minWidth: 50,
      sortable: false,
      renderCell: (data) => {
        return <div style={{ fontSize: "14px" }}>{data?.row?.pay_req_id}</div>;
      },
    },
    {
      field: "date",
      resizable: true,
      headerName: "DATE",
      sortable: false,
      minWidth: 150,
      flex: 1,

      renderCell: (data) => {
        return (
          <div style={{ fontSize: "14px", color: "#575757" }}>
            {moment(data?.row?.due_date).utcOffset("+0100").format(dateFormet)}
          </div>
        );
      },
    },
    {
      field: "invoice_number",
      resizable: true,
      headerName: "INVOICE NUMBER",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#575757" }}>
          {data?.row?.invoice_id?.inv_id || "-"}
        </div>
      ),
    },
    {
      field: "name",
      resizable: true,
      headerName: "MEMBER NAME",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#575757" }}>
          {data?.row?.member_id?.first_name +
            " " +
            data?.row?.member_id?.last_name}
        </div>
      ),
    },
    {
      field: "amount",
      resizable: true,
      headerName: "AMOUNT",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#4CAF50" }}>
          ${Math.round(data?.row?.payment_amount)}
        </div>
      ),
    },
  ];
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    props.setColToCsv(columns);
    if (props.printClicked) {
      handlePrint();
      props.setPrintClicked(false);
    }
  }, [props.printClicked]);

  return (
    <div className="activated-ledger">
      <div className="ledger-table" style={{ height: "fit-content" }}>
        <div className="home-table-container mt-0 ">
          {props.memberRequests.length === 0 && value === undefined ? (
            <MyTable
              className="family-table"
              rows={list}
              columns={columns}
              pageSize={6}
              loading={loading}
              rowHeight={60}
              checkboxSelection
              disableSelectionOnClick
              onSelectionModelChange={(newSelectionModel) => {
                setSelectionModel(newSelectionModel);
              }}
              selectionModel={selectionModel}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPage(newPage);
              }}
              page={page}
              rowCount={total}
              pagination={true}
            >
              Rows per page: {6}
            </MyTable>
          ) : (
            <MyTable
              className="family-table"
              rows={props.memberRequests}
              columns={columns}
              pageSize={6}
              loading={props.payLoading}
              rowHeight={60}
              checkboxSelection
              disableSelectionOnClick
              onSelectionModelChange={(newSelectionModel) => {
                setSelectionModel(newSelectionModel);
                props.setSelected(newSelectionModel);
              }}
              selectionModel={selectionModel}
            >
              Rows per page: {6}
            </MyTable>
          )}
        </div>
      </div>
      <div className="d-none">
        <table ref={componentRef}>
          <thead>
            {columns?.map((column, index) => (
              <th style={{ border: "1px solid" }} key={index}>
                {column?.headerName}
              </th>
            ))}
          </thead>
          <tbody>
            {props.memberRequests.length === 0 && value === undefined
              ? list?.map((datas, index) => {
                  const d = {
                    id: datas.pay_req_id,
                    date: moment(datas.due_date)
                      .utcOffset("+0100")
                      .format(dateFormet),
                    invoice_number: datas.invoice_id?.inv_id,
                    name:
                      datas.member_id?.first_name +
                      " " +
                      datas.member_id?.last_name,
                    amount: datas.payment_amount,
                  };
                  return (
                    <tr key={index}>
                      {Object.values(d)?.map((objectValue, index) => (
                        <td style={{ border: "1px solid" }} key={index}>
                          {objectValue}
                        </td>
                      ))}
                    </tr>
                  );
                })
              : props.memberRequests?.map((datas, index) => {
                  const d = {
                    id: datas.pay_req_id,
                    date: moment(datas.due_date)
                      .utcOffset("+0100")
                      .format(dateFormet),
                    invoice_number: datas.invoice_id?.inv_id,
                    name:
                      datas.member_id?.first_name +
                      " " +
                      datas.member_id?.last_name,
                    amount: datas.payment_amount,
                  };
                  return (
                    <tr key={index}>
                      {Object.values(d)?.map((objectValue, index) => (
                        <td style={{ border: "1px solid" }} key={index}>
                          {objectValue}
                        </td>
                      ))}
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default PaymentTable;
